const loop = (value, el) => {
	let offset = 0;
	let parent = el;
	do {
		if (!isNaN(parent[value])) offset += parent[value];
		parent = parent.offsetParent;
	} while (parent);
	return offset;
};

export default {
	left: (el) => loop('offsetLeft', el),
	top: (el) => loop('offsetTop', el)
};
